/* Hello Slim — Global reklam yaprak sayfası (Shopify section) */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__hsInit) return;
    root.__hsInit = true;

    var $  = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    /* ---------- veri ---------- */
    var dataEl = $('[data-hs-data]');
    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var state = { pack: '6', size: null };

    function packOf(v) {
      return (String(v.pack || '').indexOf('12') > -1) ? '12' : '6';
    }
    function findVariant(pack, size) {
      for (var i = 0; i < DATA.variants.length; i++) {
        var v = DATA.variants[i];
        if (packOf(v) === pack && String(v.size) === String(size)) return v;
      }
      return null;
    }
    function anyOfPack(pack) {
      for (var i = 0; i < DATA.variants.length; i++) {
        if (packOf(DATA.variants[i]) === pack) return DATA.variants[i];
      }
      return DATA.variants[0];
    }

    /* ---------- reveal ---------- */
    var reveals = $$('.rv');
    if ('IntersectionObserver' in window && reveals.length) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('in'); });
    }

    /* ---------- renk stüdyosu ---------- */
    var stage = $('[data-stage]');
    if (stage) {
      var sImg = $('[data-studio-img]'), sName = $('[data-studio-name]'),
          sNote = $('[data-studio-note]'), glow = $('[data-glow]');
      $$('.chips button').forEach(function (b) {
        b.addEventListener('click', function () {
          $$('.chips button').forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on');
          stage.classList.add('sw');
          var hex = b.getAttribute('data-hex');
          setTimeout(function () {
            sImg.src = b.getAttribute('data-img');
            sImg.alt = b.getAttribute('data-name');
            sName.textContent = b.getAttribute('data-name');
            sNote.textContent = b.getAttribute('data-note');
            if (glow) glow.style.background =
              'radial-gradient(closest-side,' + hex + '55,transparent 72%)';
            stage.classList.remove('sw');
          }, 170);
        });
      });
    }

    /* ---------- önden / arkadan ---------- */
    var fb = $('[data-fb]');
    if (fb) {
      var fbNote = $('[data-fb-note]');
      $$('.fb-switch button').forEach(function (b) {
        b.addEventListener('click', function () {
          $$('.fb-switch button').forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on');
          fb.classList.toggle('back', b.getAttribute('data-view') === 'back');
          if (fbNote) fbNote.textContent = b.getAttribute('data-note');
        });
      });
    }

    /* ---------- videolar ---------- */
    $$('video').forEach(function (v) {
      v.muted = true;
      var play = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      if (v.readyState >= 2) play(); else v.addEventListener('loadeddata', play, { once: true });
    });

    /* ============================================================
       SİPARİŞ MODALI
       ============================================================ */
    var mdl = $('[data-modal]'), card = mdl && mdl.querySelector('.mdl-card');
    var form = $('[data-hs-form]'), idInput = $('[data-hs-id]');
    var lastFocus = null;

    function paint() {
      var pack = state.pack;
      var v = state.size ? findVariant(pack, state.size) : null;
      var ref = v || anyOfPack(pack);

      $$('.mp-row').forEach(function (r) {
        var on = r.getAttribute('data-pack') === pack;
        r.classList.toggle('on', on);
        r.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      $$('.mdl-sizes button').forEach(function (b) {
        var code = b.getAttribute('data-size');
        b.classList.toggle('on', code === state.size);
        var cv = findVariant(pack, code);
        b.disabled = !!(cv && cv.available === false);
        b.classList.toggle('oos', !!(cv && cv.available === false));
      });

      var sb = $('[data-sum-box]');
      if (sb) sb.textContent = DATA.labels[pack] + ' · ' + DATA.pairs[pack] + (DATA.notes[pack] ? ' · ' + DATA.notes[pack] : '');
      var ss = $('[data-sum-size]');
      if (ss) ss.textContent = state.size || DATA.sizeEmpty;

      var st = $('[data-sum-total]'); if (st) st.textContent = ref.priceText;
      var ft = $('[data-foot-total]'); if (ft) ft.textContent = ref.priceText;

      var bl = $('[data-bar-label]');
      if (bl) bl.textContent = DATA.labels[pack] + (state.size ? ' · ' + state.size : '');
      var bs = $('[data-bar-sub]');
      if (bs) bs.textContent = ref.priceText + ' · ' + ref.unitText + ' ' + DATA.perPair;

      var soldOut = $('[data-sold-out]');
      if (soldOut) soldOut.hidden = !(state.size && v && v.available === false);

      if (idInput) idInput.value = v ? v.id : ref.id;
    }

    function selectPack(code) {
      if (code !== '6' && code !== '12') return;
      state.pack = code;
      paint();
    }
    function selectSize(size) {
      state.size = size;
      var w = $('[data-size-warn]'); if (w) w.hidden = true;
      var box = $('.mdl-sizes'); if (box) box.classList.remove('warn');
      paint();
    }

    function openModal(pre) {
      if (!mdl) return;
      if (pre) selectPack(pre);
      lastFocus = document.activeElement;
      mdl.hidden = false;
      document.body.classList.add('hs-lock');
      requestAnimationFrame(function () { mdl.classList.add('on'); });
      setTimeout(function () { if (card) card.focus(); }, 60);
    }
    function closeModal() {
      if (!mdl || mdl.hidden) return;
      mdl.classList.remove('on');
      document.body.classList.remove('hs-lock');
      setTimeout(function () { mdl.hidden = true; }, 240);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    $$('[data-open]').forEach(function (b) {
      b.addEventListener('click', function () { openModal(b.getAttribute('data-preselect')); });
    });
    $$('[data-close]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (b.tagName === 'A') { closeModal(); return; }
        e.preventDefault(); closeModal();
      });
    });
    $$('.mp-row').forEach(function (r) {
      r.addEventListener('click', function () { selectPack(r.getAttribute('data-pack')); });
    });
    $$('.mdl-sizes button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        selectSize(b.getAttribute('data-size'));
      });
    });

    document.addEventListener('keydown', function (e) {
      if (!mdl || mdl.hidden) return;
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key !== 'Tab' || !card) return;
      var f = Array.prototype.slice.call(card.querySelectorAll('button:not([disabled]), a[href], input, [tabindex]:not([tabindex="-1"])'))
        .filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* ---------- ödeme ---------- */
    var checkout = $('[data-checkout]');
    if (checkout && form) {
      checkout.addEventListener('click', function () {
        if (!state.size) {
          var w = $('[data-size-warn]'); if (w) w.hidden = false;
          var box = $('.mdl-sizes');
          if (box) { box.classList.add('warn'); box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
          return;
        }
        var v = findVariant(state.pack, state.size);
        if (!v || v.available === false) {
          var so = $('[data-sold-out]'); if (so) so.hidden = false;
          return;
        }
        if (idInput) idInput.value = v.id;
        checkout.disabled = true;
        form.submit();
      });
    }

    /* ---------- beden yardımcısı ---------- */
    var helper = $('[data-helper]');
    if (helper) {
      var pickedWaist = null, pickedFit = null;
      var fitStep = $('[data-fit-step]'), out = $('[data-out]'),
          outSize = $('[data-out-size]'), outWhy = $('[data-out-why]');
      var whyTrue = ($('[data-why-true]') || {}).textContent || '';
      var whyUp   = ($('[data-why-up]')   || {}).textContent || '';
      var whySnug = ($('[data-why-snug]') || {}).textContent || '';
      var order = $$('[data-waist] button').map(function (b) { return b.getAttribute('data-size'); });

      function render() {
        if (!pickedWaist) return;
        var i = order.indexOf(pickedWaist);
        var final = pickedWaist, why = whyTrue;
        if (pickedFit === 'relaxed' && i > -1 && i < order.length - 1) {
          final = order[i + 1]; why = whyUp;
        } else if (pickedFit === 'snug') {
          why = whySnug;
        }
        outSize.textContent = final;
        outWhy.textContent = why;
        out.hidden = false;
        selectSize(final);
      }

      $$('[data-waist] button').forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-waist] button').forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on');
          pickedWaist = b.getAttribute('data-size');
          if (fitStep) fitStep.hidden = false;
          render();
        });
      });
      $$('[data-fit] button').forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-fit] button').forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on');
          pickedFit = b.getAttribute('data-fit');
          render();
        });
      });
    }

    /* ---------- yüzen bar ---------- */
    var fbar = $('[data-fbar]'), hero = root.querySelector('.hero');
    function onScroll() {
      var past = hero ? (window.scrollY > hero.offsetHeight * 0.8) : (window.scrollY > 500);
      var atEnd = (window.innerHeight + window.scrollY) > (document.body.offsetHeight - 150);
      if (fbar) fbar.classList.toggle('on', past && !atEnd);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();

    paint();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('.hsg')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* tema editöründe bölüm yeniden yüklenince */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('.hsg') : null;
    if (el) init(el);
  });
})();